export default function getModelId (vue) {
  return vue.$route.query.id
}
